module.exports = __webpack_public_path__ + "static/profile-1c4fa99556652c314d2d40283fcccb95.jpg";